import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;

  h1 {
    display: flex;
    align-items: center;
    font-size: 1.5rem;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.secondary};

    svg {
      fill: ${({ theme }) => theme.colors.secondary};
      width: 1.75rem;
      height: 1.75rem;
      margin-right: 0.5rem;
    }
  }

  .close-div {
    padding: 0;
    height: 20px;

    button {
      color: #fff;
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      width: 20px;
      height: 19px;
      border-radius: 100%;
      padding: 0;
      border: none;

      :hover {
        cursor: pointer;
      }
    }
  }
`;

export const ContentModal = styled.div`
  display: flex;
  flex-direction: column;

  h1 {
    display: flex;
    align-items: center;
    font-size: 1.5rem;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.secondary};

    svg {
      stroke: ${({ theme }) => theme.colors.secondary};
      width: 1.75rem;
      height: 1.75rem;
      margin-right: 0.5rem;
    }
  }

  .checkbox {
    display: flex;
    gap: 0.5rem;
    max-width: 1rem;
    max-height: 1rem;
  }

  .container {
    margin: 1rem 0;

    .containerStatus {
      width: 100%;
      display: flex;
      gap: 4rem;
      align-items: center;
      margin: 1rem 0;

      .contentStatus {
        display: flex;
        align-items: center;
        gap: 0.2rem;

        .MuiCheckbox-root {
          padding: 0;
        }

        .Mui-checked {
          color: ${({ theme }) => theme.colors.tertiary_500};
        }

        label {
          font-size: 1.1rem;
          color: ${({ theme }) => theme.colors.tertiary_500};
          padding: 0;
          cursor: pointer;
        }
        .labelDisabled {
          cursor: auto;
        }
      }
    }
  }

  .containerAttachment {
    display: flex;
    flex-direction: column;

    .contentAttachment {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      .contentDropzone {
        display: flex;
        align-self: center;
      }
    }

    .error {
      color: ${({ theme }) => theme.colors.error};
      display: flex;
      align-items: center;
      align-self: center;
      font-size: 1rem;
      flex-wrap: nowrap;
      margin: 1rem 0;

      svg {
        margin-right: 2px;
        font-size: 1rem;
        padding-bottom: 0.1rem;
      }
    }
  }

  .content-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5rem;
    padding-top: 3rem;
  }
`;
